import request from '@/utils/request'

let CoursewareApi = {

  /*课件列表*/
  list(data) {
    return request._post('/shop/plus.courseware.Index/index', data);
},
/*添加课件*/
add(data) {
    return request._post('/shop/plus.courseware.Index/add', data);
},
/*修改课件*/
edit(data) {
    return request._post('/shop/plus.courseware.Index/edit', data);
},
/*删除课件*/
del(data) {
    return request._post('/shop/plus.courseware.Index/del', data);
},
/*课件详情*/
detail(data) {
  return request._post('/shop/plus.courseware.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.courseware.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.courseware.Setting/getSetting', data, errorback);
    },
}
export default CoursewareApi;



// WEBPACK FOOTER //
// ./src/api/courseware.js